module.exports = __webpack_public_path__ + "static/media/2.484455a1.jpg";